import { Typography } from "antd";
import type { ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import type { UserRoles } from "~enums/userRoles";
import type { LabelValue } from "~types/labelValue";
import { SELECT_ALL_VALUE } from "../constants/ui";

type Props = {
  role?: UserRoles;
  userName?: string;
  scope: string | null;
  scopeValues: LabelValue[] | null;
};

const ConfirmationText = ({ role, userName, scope, scopeValues }: Props) => {
  const roleName = (
    <span>
      <strong>
        <FormattedMessage id={`permissions.userRole.${role}`} />
      </strong>
    </span>
  );

  if (scope === SELECT_ALL_VALUE) {
    return (
      <Typography.Text>
        <FormattedMessage id="permissions.user.role.actions.confirm.all" values={{ roleName, userName }} />
      </Typography.Text>
    );
  }

  const scopeType = <FormattedMessage id={scope?.toLowerCase()} />;
  const scopeList = (
    <span>
      {scopeValues?.map<ReactNode>(({ label }) => <strong key={label}>{label}</strong>).reduce((prev, curr) => [prev, ", ", curr])}
    </span>
  );

  return <FormattedMessage id="permissions.user.role.actions.confirm" values={{ roleName, scopeType, scopeList, userName }} />;
};

export default ConfirmationText;
